import { cn } from "@/lib/utils";
import { useContactModal, type ContactModalFallback } from "./ContactModalProvider";

// ─────────────────────────────────────────────────────────────────────────────
// ContactNameLink — renders a contact name as a button that opens the shared
// read-only contact modal. Use everywhere a contact name appears OUTSIDE the
// campaign hub/tasks (list builder, account contact tab, roster, targeting).
// Standard: launch-platform/template/modules/contact_modal.md §3.
// ─────────────────────────────────────────────────────────────────────────────

interface ContactNameLinkProps {
  /** contacts.id (may be null for unmatched contacts — modal shows the fallback). */
  contactId: string | null;
  /** Display text. Falls back to the fallback name, then "Contact". */
  name?: string | null;
  fallbackData?: ContactModalFallback | null;
  className?: string;
}

export function ContactNameLink({ contactId, name, fallbackData, className }: ContactNameLinkProps) {
  const { openContact } = useContactModal();
  const label =
    name ||
    fallbackData?.full_name ||
    [fallbackData?.first_name, fallbackData?.last_name].filter(Boolean).join(" ") ||
    "Contact";

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        openContact({ contactId, fallbackData });
      }}
      className={cn(
        "text-left font-medium text-primary hover:underline focus:underline focus:outline-none",
        className,
      )}
    >
      {label}
    </button>
  );
}
